export default "__VITE_ASSET__2d6f8731__"